import { Box, IconButton, Input, ListItemText, Menu, MenuItem, Skeleton, Switch, Typography } from '@mui/material'
import React, { useMemo, useRef, useState } from 'react'
import AddIcon from '../icons/AddIcon'
import { useDispatch, useSelector } from 'react-redux';
import { updateTeamState } from '../../../redux/teamSlice';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import CustomSwitch from '../../../components/CustomSwitch';
import usePermissions from '../../../hooks/usePermissions';
import { updateTeamScope, viewTeamMembers } from '../../teams/actions';
import { PERMISSION } from '../../../constants/constants';
import CustomTooltip from '../../../components/CustomTooltip';
// import { customTheme as theme } from '../../../theme/customTheme';
import { generateLighterContrastColor } from '../../../utils/commonServices';
import useCustomTheme from '../../../theme/useCustomTheme';
import CustomCard from '../../../components/CustomCard';
import SearchIcon from "@mui/icons-material/Search";
import { updateState } from '../../../redux/commonSlice';
import useOrganisationProjectActions from '../../events/useOrganisationProjectActions';
import { useOrganisationsList } from '../hooks/useOrganisationsList';
import CustomScrollToBottom from '../../../components/CustomScrollToBottom';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const AllOrganizationsCard = ({setSelectedOrganisation, selectedOrganisation}) => {

    const commonReducer = useSelector((state) => state.root.commonReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const dispatch = useDispatch()
  
    // const [searchedArray, setSearchedArray] = useState(organisations)
    // const [selectedOrganisation, setSelectedOrganisation] = useState()
   
    const [hasPermission] = usePermissions()
    const [theme ] = useCustomTheme()
    const [searchString, setSearchString] = useState("");
   
    const { getOrganisationProjectsList} = useOrganisationProjectActions()
    const { data: orgListData, isLoading: isOrgsLoading } = useOrganisationsList()

    const organisationList = useMemo(()=> {
      return (orgListData?.length > 0 ? orgListData : null) ?? commonReducer.organisation_list ?? []
    },[orgListData, commonReducer.organisation_list])

    const displayedOrgs = useMemo(()=> {
      if (!searchString) return organisationList
      return organisationList.filter(org => org.name?.toLowerCase().includes(searchString.toLowerCase()))
    }, [organisationList, searchString])

   

  

 

  

    // useEffect(()=>{
    //   setSelectedOrganisation(commonReducer.organisation_list[0].name)
    // },[commonReducer.organisation_list])

  


    const selectOrganisationHandler = (org)=>{
    
        setSelectedOrganisation(org)
        // console.log(org, 'orgggggggggggggggggggggggggggggggggggggggggggggg')
        dispatch(updateState({selected_organisation: org}))
        // getOrganisationProjectsList({organisation_id : org?.id})
    }



    const handleSearch = (e) => {
        setSearchString(e.target.value);
      };

    const orgListRef = useRef(null);

    useEffect(() => {
      if (!selectedOrganisation && orgListRef.current) {
        const el = orgListRef.current;
        const start = el.scrollTop;
        if (start === 0) return;
        // ~800ms per "screen height" of scroll, min 400ms, max 2400ms
        const duration = Math.min(Math.max((start / el.clientHeight) * 800, 400), 2400);
        // Disable CSS scroll-behavior so it doesn't fight the RAF animation
        el.style.scrollBehavior = 'auto';
        const startTime = performance.now();
        const easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / duration, 1);
          el.scrollTop = start * (1 - easeInOutCubic(progress));
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            el.style.scrollBehavior = 'smooth';
          }
        };
        requestAnimationFrame(step);
      }
    }, [selectedOrganisation]);

   

  return (
    <CustomCard   sx={{  backgroundColor:'#ffffff !important', height:'100%'}}>
    <Box className='flex col' sx={{width:'100%', height:'100%',  borderRadius:'10px', backgroundColor:'#ffffff'}}>
        <Box className='flex j-between a-end' mb={2} sx={{ padding:'20px 20px 0 20px'}} gap={5}>
            <Typography sx={{fontSize:{xs:'10px',sm:'11px',md:'13px',lg:'15px',xl:'22px'}}}>Organizations</Typography>
            {/* {hasPermission(PERMISSION.ORGANISATION.TEAM.CREATE) && <AddIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' : generateLighterContrastColor(theme.palette.primary.main)} onClick= {openCreateTeamsHandler}  sx={{fontSize:{xs:'20px',sm:'30px',md:'30px', lg:'26px',xl:'50px'}, cursor: 'pointer', }}/>} */}

            <Box id="search" 
                    // sx={{flex: 1}} 
                >
                    <Input
                 
                        value={searchString}
                        onChange={handleSearch}
                        sx={{
                            borderBottom: 1,
                            borderColor: "#333333",
                            input: {
                                fontSize: { xs: '10px', md: '11px', lg: '12px', xl: '18px' },
                                fontWeight: 400,
                                color: "#000000",
                            },
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:1, fontSize: {xs:'10px',md:'12px',lg:'14px',xl:'21px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'10px',md:'12px',lg:'14px',xl:'21px'}}}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                </Box>
         
        </Box>
        <Box ref={orgListRef} className='flex col' style={{overflowY:'scroll', height:'100%', scrollBehavior:'smooth'}}>
          { isOrgsLoading && organisationList.length === 0 ?
            [1,2,3].map(i => <Box key={i} sx={{width:'90%', ml:1, mr:1, mt:1.5, height:'20px', backgroundColor:'#dddddd', opacity:0.5}}><Skeleton variant='rounded' animation='pulse' width='100%' height='100%'/></Box>)
          : displayedOrgs?.length === 0 ? 
          <Typography sx={{fontSize: 16, color: '#878887', fontWeight: 300, textAlign: 'center', mt:10}} >No Organisation to display. <br/> 
</Typography>
            : displayedOrgs.map((org, index )=>(
           ( org.name !== null && org.name !== '') &&   <CustomTooltip
          // title={org?.name}
           placement= "top"
           PopperProps={{
             modifiers: [
               {
                 name: "offset",
                 options: {
                   offset: [-20, -20],
                 },
               },
             ],
           }} 
           >
              {selectedOrganisation?.id == org?.id &&  <CustomScrollToBottom />}
            <Box  key={org.id} className='flex a-center j-between' onClick={()=>selectOrganisationHandler(org)} sx={{cursor:'pointer', backgroundColor: org.id == selectedOrganisation?.id && `${theme.palette.primary.main}99`, padding:'8px 20px',  "&:hover": {backgroundColor: "#dedede"},gap:1}} >
            
                <Box  flex={5} sx={{ width:'80%'}}>
                  <Typography  sx={{fontSize:{xs:'8px',sm:'8px',md:'10px',lg:'12px',xl:'17.5px'}, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', width:'100%', fontFamily:'Rubik', color:'#000', textTransform:'capitalize'}}>{org?.name}</Typography>
               </Box>
              {org?.is_event_changed && <Box className='flex a-center' >
                  
                  <FiberManualRecordIcon sx={{fontSize:{xs:'10px',sm:'12px',md:'14px',lg:'16px', xl:'20px'}, color:'#00ceff'}}/>
                  
               </Box>}
             
             
                  {/* {location.pathname =='/dashboard' && hasPermission(PERMISSION.ORGANISATION.TEAM.DELETE) && (<>
                  <Box flex={2} className='flex a-center j-end' >
                    <MoreHorizIcon onClick={(e)=>teamOptionsHandler(e,team)} sx={{fontSize:{xs:'10px',sm:'11px',md:'13px',lg:'15px',xl:'21px'}, color:'black'}}/>
                  </Box>
                  <Menu
                  anchorEl={menuAnchorEl}
                  open={selectedTeamId === team.id}
                  onClose={closeMenuHandler}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: 0,
                    horizontal: 15
                  }}
                  elevation={3}
                  PaperProps={{sx:{
                     width:'180px'
                  }}}
                  
                >
              {  hasPermission(PERMISSION.ORGANISATION.TEAM.UPDATE_SCOPE) &&  <MenuItem disableRipple gap={2} sx={{display:'flex', justifyContent:'space-between', '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}>
                    <ListItemText >
                      <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px' } , color:'#08231B', fontWeight: 600,}}>Private</Typography>      
                    </ListItemText>
                    <div style={{justifySelf:'flex-end'}}>
                        <CustomSwitch
                            checked={checked}
                            onChange={(e)=> privacyChangeHandler(e, team)}
                        />
                    </div>
                  </MenuItem>}
                  { hasPermission(PERMISSION.ORGANISATION.TEAM.RENAME) && <MenuItem disableRipple onClick={(e) => renameTeamHandler(e,team)} sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70` }}}>
                    <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px' }  , color:'#08231B', fontWeight: 600,}}>Rename team</Typography></ListItemText>
                  </MenuItem>}
                 {hasPermission(PERMISSION.ORGANISATION.TEAM.DELETE) &&  <MenuItem disableRipple onClick={(e) => deleteTeamHandler(e, team)} sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70` }}}>
                    <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px'} , fontWeight: 600, color: '#ce0101' }}>Delete team</Typography></ListItemText>
                  </MenuItem>}
                </Menu>
                  </>)  } 
               {location.pathname !== '/dashboard' && team.id === teamsReducer?.selected_team?.id && <CheckRoundedIcon style={{fontSize:'16px', fontWeight:600}}/>}  */}
            </Box>
            </CustomTooltip> 
          ))}
        </Box>
    </Box>
    </CustomCard>
  )
}

export default AllOrganizationsCard